import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();

    if (loading || user === null) {
        return (
            <div className="flex h-screen items-center justify-center text-[#59605B]" data-testid="auth-loading">
                Yükleniyor...
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (roles && !roles.includes(user.role)) {
        // Redirect to the correct page based on role
        const map = { garson: "/garson", mutfak: "/mutfak", kasa: "/kasa", admin: "/admin" };
        return <Navigate to={map[user.role] || "/login"} replace />;
    }
    return children;
}
